var map = {
	"./element.js": "u0Ar",
	"./menus.js": "AFY2",
	"./public.js": "/ut4"
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "Zbbw";


//////////////////
// WEBPACK FOOTER
// ./src/i18n/langs/cn nonrecursive \.js$
// module id = Zbbw
// module chunks = 13